import { createRoot } from 'react-dom/client';

import { pdfjs } from 'react-pdf';
import { useTokenRefresh } from '../../hooks/useTokenRefresh';
import { GlobalStateProvider } from '../context/GlobalStateContext'; // Adjust path
import { App } from './root';
import { Router } from './router';
import { StoreProvider } from './store';
const _preserve = React.version;

// Set worker source, adjust path as needed or use CDN
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

import React from 'react';
import { setGlobalFetchWatcher } from '../../hooks/fetchWithWatch';
import { LoggerProvider } from '../context/LoggerContext';

setGlobalFetchWatcher((url, options, response, error) => {

  if (response && !response.ok) {
    console.warn(`⚠️ Request failed: ${url} (${response.status})`);
  }

  if (error) {
    console.error(`🚨 Network error on ${url}:`, error);
  }
});

//const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
//const { idPropiedad, setIdPropiedad } = useGlobalState();



const RootWrapper = () => {

  useTokenRefresh('/api/auth/refresh', 60 * 10 * 1000); // refresh every 10 minutes
  return (
    <LoggerProvider>
      <StoreProvider>
        <GlobalStateProvider>
          <App>
            <Router initialPage="home" />
          </App>
        </GlobalStateProvider>
      </StoreProvider>
    </LoggerProvider>
  );
};

// index.tsx
createRoot(document.getElementById('app')!).render(<RootWrapper />);